<template>
  <v-layout class="mt-4" justify-center>
    <v-flex xs10>
      <v-card class="tabs_style">
        <v-tabs centered color="primary" dark text grow>
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab v-if="!partnerActive" href="#tab-1" class="text-capitalize">
            {{$translate('GENERAL')}}
          </v-tab>
          <v-tab href="#tab-2" class="text-capitalize">
            {{$translate('PREFERENCES')}}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-3" class="text-capitalize">
            {{$translate('USER_ROLES')}}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-4" class="text-capitalize">
            {{$translate('CUSTOMERS')}}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-5" class="text-capitalize">
            {{$translate('PARTNERS')}}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-6" class="text-capitalize">
            {{$translate('PARTNER_GROUPS')}}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-7" class="text-capitalize">
            Exact CSV
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-8" class="text-capitalize">
            {{ $translate("CATEGORIES") }}
          </v-tab>
          <v-tab v-if="!partnerActive" href="#tab-9" class="text-capitalize">
            {{ $translate("MAP_ICONS") }}
          </v-tab>

          <v-tab-item  v-for="i in tabsNumber" :key="i" :value="'tab-' + i" justify-center>
            <v-container grid-list-xl text-xs-center>
              <Account-General v-if="i === 1 && !partnerActive" class="tab_container"/>
              <Account-Preferences v-if="i === 2" class="tab_container"/>
              <Account-Roles v-if="i === 3 && !partnerActive && partnersLoaded" class="tab_container" :partners = "partners"/>
              <Account-Users v-if="i === 4" class="tab_container"/>
              <Account-Partners v-if="i === 5 && !partnerActive" class="tab_container"/>
              <Account-PartnerGroups v-if="i === 6 && !partnerActive" class="tab_container"/>
              <Account-ExactCsv v-if="i === 7 && !partnerActive" class="tab_container"/>
              <Account-Categories v-if="i === 8 && !partnerActive" class="tab_container"/>
              <Account-MapIcons v-if="i === 9 && !partnerActive" class="tab_container"/>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import Account_Preferences from "./Account_Preferences";
import Account_Roles from "./Account_Roles";
import Account_Users from "./Account_Users";
import Account_General from "./Account_General";
import Account_Partners from "./Account_Partners";
import Account_ExactCsv from "./Account_ExactCsv";
import Account_Categories from "./Account_Categories";
import Account_MapIcons from "./Account_MapIcons";
import Account_PartnerGroups from './Account_PartnerGroups';
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Account_Main",
  components: {
    "Account-General": Account_General,
    "Account-Preferences": Account_Preferences,
    "Account-Roles": Account_Roles,
    "Account-Users": Account_Users,
    "Account-Partners": Account_Partners,
    "Account-ExactCsv": Account_ExactCsv,
    "Account-Categories": Account_Categories,
    "Account-MapIcons": Account_MapIcons,
    "Account-PartnerGroups": Account_PartnerGroups,
  },
  data() {
    return {
      partnerActive: false,
      tabsNumber: 9,
      partners: [],
      partnersLoaded: false
    };
  },
  beforeDestroy() {
     let page = "Account_Main";
    this.$store.commit("setCurrentComponent", page);
  },
  mounted() {
    if (this.$store.getters["auth/userLevel"] == 6) {
      this.partnerActive = true;
    }
    else {
      this.getPartners();
    }
  },
  methods: {
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: 'AccountFunctionLibrary::getPartners',
      };
      dssRequest.doRequest(
        response => {
          console.log("The call [AccountFunctionLibrary::getPartners] on Account [%s] in component [Account_Main] succeeded", this.currentAccountId, response);
          // Clear the current partners array
          this.partners = [];
          this.partnersLoaded = true;
          if(response.data.hasOwnProperty('PartnerList'))
          {
            this.partners = response.data.PartnerList;
          }
        },
        error => {
          console.log("The call [AccountFunctionLibrary::getPartners] on Account [%s] in component [Account_Main] failed", this.currentAccountId, error);
        },
        'communicateWithDBLibrary',
        this.$store.getters["getCurrentAccountId"],
        payload
      );
    }
  }
};
</script>

<style lang="scss" scoped>

.tab_container {
  height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.tabs_style {
  border-radius: 2em;
}
</style>
